import React, { ReactNode } from 'react';

interface PageProps {
    children: ReactNode;
    className?: string;
}

const Page: React.FC<PageProps> = ({ children, className }) => {
    return (
        <div className={`flex flex-col max-w-[1184px] p-XL 2xl:p-NONE m-auto mb-2XL md:mb-4XL ${className || ''}`}>
            {children}
        </div>
    );
};

export default Page;